import CardInfo from 'components/checkout/caap/payment/paymentlist/CardInfo';
import UpdateExpiration from 'components/checkout/caap/payment/paymentlist/UpdateExpiration';
import NeedsConfirmation from 'components/checkout/caap/payment/paymentlist/NeedsConfirmation';

const PaymentListItem = componentParams => {
  const {
    addCreditCardNumber,
    showCCIVRPayment,
    errors,
    errorList,
    expirationMonth,
    expirationYear,
    fullName,
    isChecked,
    isExpired,
    isFetchingCheckoutData,
    newPayment,
    onPaymentTypeFieldChange,
    onUpdateCreditCardClick,
    paymentInstrumentId,
    paymentType,
    selectedPaymentNeedsConfirmation,
    type
  } = componentParams;

  if (isExpired && isChecked) {
    return (
      <UpdateExpiration
        addCreditCardNumber={addCreditCardNumber}
        errors={errors}
        errorList={errorList}
        expirationMonth={expirationMonth}
        expirationYear={expirationYear}
        fullName={fullName}
        isFetchingCheckoutData={isFetchingCheckoutData}
        newPayment={newPayment}
        onPaymentTypeFieldChange={onPaymentTypeFieldChange}
        onUpdateCreditCardClick={onUpdateCreditCardClick}
        paymentInstrumentId={paymentInstrumentId}
        paymentType={paymentType}
      />
    );
  }

  if (selectedPaymentNeedsConfirmation && isChecked) {
    return (
      <NeedsConfirmation showCCIVRPayment={showCCIVRPayment} type={type} paymentInstrumentId={paymentInstrumentId} />
    );
  }

  return (
    <CardInfo
      addCreditCardNumber={addCreditCardNumber}
      expirationMonth={expirationMonth}
      expirationYear={expirationYear}
      fullName={fullName}
      isExpired={isExpired}
      paymentType={paymentType}
    />
  );
};

export default PaymentListItem;
